import React, { useEffect } from 'react';
import './menuPaginas.css';
import { links } from '../../json/headerLinks';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';




const MenuPaginas = () => {
    const { pagina } = useParams();
    const arreglo=(links.find(obj => {return obj.nombre === pagina; }));
   
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      


  return (
    <div className='container transparencia-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='transparencia_title'>
                    <h3 className='title-wine'>{pagina}</h3>
                    <hr className='hr-gob'/>
                </div>
            </div>
        </div>
        <div className='row'>
            
            <div className='row'>
            {
                arreglo.submenu.map((item, index)=>(
                    <div key={ index } className='col-lg-4 col-sm-12  transparencia_item'>
                        <Link to={ item.subMenuUrl } target='_blank'>{ item.subMenuNombre }</Link>
                    </div>
                ))
            }
        </div>
        </div>
    </div>
  )
}

export default MenuPaginas